module.exports = __webpack_public_path__ + "static/media/logo-white-mobile.48a23985.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-white-mobile.svg
// module id = 1011
// module chunks = 1